export default {
    alarm: {
        default_layer: 'Default Level',
        alarm_object: 'Alarm Recipient',
        alarm_mail: 'Email Notification',
        alarm_msg: 'SMS Alarm',
        alarm_phone: 'Voice Notification',
        alarm_cause: 'Alarm Cause',
        alarm_time: 'Alarm Time',
        repeat_times: 'Repeat Times',
        repeat_interval: 'Repeat Interval',
        alarm_repeat: 'Duplicate Alarm',
        alarm: 'Alarm',
        empty_time: 'Alarm Time/Point  are required.',
        open: 'Alarm On',
        close: 'Alarm Off',
        add_trigger: 'New Trigger',
        alarm_switch: 'Alarm Toggle'
    }
};
